const SEARCHABLE_MULTI_SELECTS = ["v-autocomplete", "v-combobox"];

export default {
  install(Vue) {
    Vue.mixin({
      created() {
        if (!this.multiple || !SEARCHABLE_MULTI_SELECTS.includes(this.$options.name)) {
          return;
        }
        this.$on("change", () => {
          this.internalSearch = null;
        });
      },
    });
  },
};
